namespace Areas.Analysis.Staff.List {
    "use strict";
    
    export function viewFromCellStaffList(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const linkInfo = `<a href= '/Employee/Time/Index/${employeeId}'>Timesheet</a>`
        cellElement.html(linkInfo);
    }
    
    export function editFromCellStaffList(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const linkInfo = `<a href= '/Employee/Edit/Index/${employeeId}' target=_blank >View</a>`
        cellElement.html(linkInfo);
    }
    
}
